// src/components/store/CategoryBubbles.tsx
"use client";

import CategorySectionRenderer from "./sections/categories";

export default function CategoryBubbles(props: any) {
  return <CategorySectionRenderer {...props} />;
}

export * from "./sections/categories";